import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { ModelImage } from './model-image.model';
import { ModelImagePopupService } from './model-image-popup.service';
import { ModelImageService } from './model-image.service';
import { ImageResource, ImageResourceService } from '../image-resource';
import { Seller, SellerService } from '../seller';
import { Model, ModelService } from '../model';
@Component({
    selector: 'dcs-model-image-dialog',
    templateUrl: './model-image-dialog.component.html'
})
export class ModelImageDialogComponent implements OnInit {

    modelImage: ModelImage;
    authorities: any[];
    isSaving: boolean;

    shutdownscreens: ImageResource[];

    shutdownscreennopowers: ImageResource[];

    imageresources: ImageResource[];

    sellers: Seller[];

    models: Model[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private modelImageService: ModelImageService,
        private imageResourceService: ImageResourceService,
        private sellerService: SellerService,
        private modelService: ModelService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['modelImage']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.imageResourceService.query( { filter: 'modelimage-is-null' } ).subscribe( (res: Response) => {
            if (!this.modelImage.shutdownscreen || !this.modelImage.shutdownscreen.id) {
                this.shutdownscreens = res.json();
            } else {
                this.imageResourceService.find( this.modelImage.shutdownscreen.id ).subscribe( (subRes: ImageResource) => {
                    this.shutdownscreens = [ subRes ].concat( res.json() );
                }, (subRes: Response) => this.onError( subRes.json() ) );
            }
        }, (res: Response) => this.onError( res.json() ) );
        this.imageResourceService.query( { filter: 'modelimage-is-null' } ).subscribe( (res: Response) => {
            if (!this.modelImage.shutdownscreenNoPower || !this.modelImage.shutdownscreenNoPower.id) {
                this.shutdownscreennopowers = res.json();
            } else {
                this.imageResourceService.find( this.modelImage.shutdownscreenNoPower.id ).subscribe( (subRes: ImageResource) => {
                    this.shutdownscreennopowers = [ subRes ].concat( res.json() );
                }, (subRes: Response) => this.onError( subRes.json() ) );
            }
        }, (res: Response) => this.onError( res.json() ) );
        this.imageResourceService.query().subscribe(
            (res: Response) => {
                this.imageresources = res.json();
            }, (res: Response) => this.onError( res.json() ) );
        this.sellerService.query().subscribe(
            (res: Response) => { this.sellers = res.json(); }, (res: Response) => this.onError(res.json()));
        this.modelService.query().subscribe(
            (res: Response) => { this.models = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        if (this.modelImage.id !== undefined) {
            this.modelImageService.update(this.modelImage)
                .subscribe((res: ModelImage) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        } else {
            this.modelImageService.create(this.modelImage)
                .subscribe((res: ModelImage) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        }
    }

    private onSaveSuccess (result: ModelImage) {
        this.eventManager.broadcast({ name: 'modelImageListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }

    trackImageResourceById(index: number, item: ImageResource) {
        return item.id;
    }

    trackSellerById(index: number, item: Seller) {
        return item.id;
    }

    trackModelById(index: number, item: Model) {
        return item.id;
    }
}

@Component({
    selector: 'dcs-model-image-popup',
    template: ''
})
export class ModelImagePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private modelImagePopupService: ModelImagePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.modalRef = this.modelImagePopupService
                    .open(ModelImageDialogComponent, params['id']);
            } else {
                this.modalRef = this.modelImagePopupService
                    .open(ModelImageDialogComponent);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model-image/model-image-dialog.component.ts